import styled, { css } from "styled-components";
import { mediaMinWidth, mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  background-color: #fff;
  border: 5px solid #e4e5e7;
  border-radius: 15px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  color: #616161;
  max-width: 100%;

  &:hover {
    color: #000;
  }

  &:first-child {
    border-top: 0px solid #e4e5e7;
  }

  &:last-child {
    margin-bottom: 80px;

    ${mediaMaxWidth.tablet`
      margin-bottom: 140px;
    `}
  }

  ${mediaMinWidth.smallDesktop`
    width: 900px !important;
    right: 0;
    margin: 0 auto;
  `}
`;

export const Column = styled.div`
  display: ${(props) => (props.isIE ? "table" : "flex")};
  flex-direction: column;
  flex: ${(props) => props.flexSize};
  width: ${(props) => !props.flexSize && "275px"};
  width: ${(props) => props.ieWidth && "150px"};
  justify-content: space-evenly;
  align-items: ${(props) => props.center && "center"};
  text-transform: ${(props) => props.capitalize && "capitalize"};
  cursor: ${(props) => props.arrow && "pointer"};
  font-size: ${(props) => props.arrow && "1.8em"};
  position: ${(props) => props.flexSize === "unset" && "absolute"};
  right: ${(props) => props.flexSize === "unset" && "40px"};

  svg.fa-chevron-right {
    position: absolute;
    right: 20px;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }

  ${mediaMaxWidth.tablet`
    width: ${(props) => !props.flexSize && "280px"};
  `}

  ${mediaMinWidth.tablet`
    display: ${(props) => props.hideOnDesktop && "none"};
    color: ${(props) => props.arrow && props.pinkArrow && "#79D9D9"};
    color: ${(props) => props.arrow && props.offerMade && "rgb(39, 174, 96)"};
  `}

  ${mediaMaxWidth.tablet`
    display: ${(props) => props.hideOnTablet && "none"};
    width: ${(props) => !props.flexSize && "350px"};

    svg.fa-chevron-right {
      right: 15px;
    }
  `}

  ${mediaMaxWidth.phone`
    width: ${(props) => !props.flexSize && "290px"};
    font-size: ${(props) => props.arrow && "1.2em"};
  `}

  ${mediaMaxWidth.smallPhone`
    width: ${(props) => !props.flexSize && "250px"};
    font-size: ${(props) => props.arrow && "1.1em"};
    right: ${(props) => props.flexSize === "unset" && "30px"};
  `}
`;

const jobTitleCommonStyles = css`
  color: #333 !important;
  display: flex;
  flex: 1;
  position: relative;
`;

export const JobTitleLink = styled.a`
  ${jobTitleCommonStyles}
  transition: 0.1s ease-in-out;
  text-decoration: underline !important;

  &:hover {
    color: #402680 !important;
  }
`;

export const JobTitleSpan = styled.span`
  ${jobTitleCommonStyles}
`;

export const Top = styled.div`
  display: flex;
  flex: 1;
  font-size: ${(props) => (props.titleField ? "1em" : "0.95em")};
  justify-self: center;
  margin-bottom: 2.5px;
  min-height: 22px;

  ${JobTitleLink}, ${JobTitleSpan} {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
    display: inline-block;
  }

  strong {
    margin-right: 3px;
    padding-right: 25px;
    display: flex;
    position: relative;

    .__react_component_tooltip.place-right {
      margin-left: -55px;
      top: unset !important;
      margin-top: -29px;
      text-align: center;
      font-weight: 400;
    }
  }

  svg {
    display: flex;
    align-self: center;
    margin: 0 12px;
  }

  ${mediaMaxWidth.phone`
    font-size: ${(props) => (props.titleField ? "0.85em" : "0.8em")};

    strong {
      padding-right: 30px;
    }

    .__react_component_tooltip.place-top {
      margin-top: -2px;
      top: unset !important;
      left: unset !important;
      right: 60px !important;

      &:after {
        display: none;
      }
    }

    .__react_component_tooltip.place-right {
      margin-top: -2px !important;
      left: unset !important;
      right: 60px !important;

      &:after {
        display: none;
      }
    }
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: ${(props) => (props.titleField ? "0.8em" : "0.75em")};
  `}
`;

export const FeedbackOverdue = styled.div`
  top: 5px;
  position: absolute;
  right: 0;
  color: #79D9D9;
  width: 20px;

  svg {
    margin: 0;
    font-size: 0.8em;
    visibility: inherit;
  }

  ${mediaMaxWidth.smallPhone`
    display: none;
  `}
`;

export const BadgeTooltip = styled.div`
  font-weight: 600;
`;
export const Badge = styled.span`
  color: #666;
  margin-left: 5px;
  font-family: sans-serif;
  letter-spacing: 0.05em;
  font-weight: bold;
  font-size: 0.6em;
  background-color: #fff;
  position: relative;
  border: 1px solid #666;
  text-transform: uppercase;
  top: 2px;
  padding: 2px 5px;
  border-radius: 20px;
  height: 16px;

  ${mediaMaxWidth.phone`
    top: 1px;
    height: 15px;
  `}
`;

export const Bottom = styled.div`
  display: flex;
  flex: 1;
  margin-top: 2.5px;
  font-size: 0.95em;
  cursor: ${(props) => props.hover && "pointer"};
  width: ${(props) => props.numbers && "100%"};

  strong {
    margin-right: 3px;
  }

  svg {
    display: flex;
    align-self: center;
    margin: 0 7px;
  }

  ${mediaMinWidth.tablet`
    flex-direction: ${(props) => props.desktopStack && "column"};
    flex-direction: ${(props) => props.desktopStack && props.numbers && "row"};
    flex-flow: ${(props) =>
      props.desktopStack && props.location && "column-reverse"};
    justify-content: space-around;
  `}

  ${mediaMaxWidth.phone`
    font-size: 0.85em;
  `}

  ${mediaMaxWidth.smallPhone`
    font-size: 0.75em;
  `}

  .__react_component_tooltip.place-left {
    margin-left: -55px;
    top: unset !important;
    margin-top: -25px;
    text-align: center;
  }

  .__react_component_tooltip.place-left:after {
    margin-top: 5px;
  }
`;

export const BottomItem = styled.div`
  flex-direction: ${(props) => props.numbers && "column"};
  display: ${(props) => props.numbers && "flex"};
  justify-content: space-evenly;
  flex: ${(props) => props.numbers && "1"};
  color: ${(props) => props.offerMade && "rgb(39, 174, 96)"};
  font-weight: ${(props) => props.offerMade && "700"};
`;

export const Divider = styled.div`
  margin: 0 7px;

  ${mediaMinWidth.tablet`
    display: none;
  `}
`;

export const Number = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  cursor: pointer;
  color: ${(props) => props.highlight && "#79D9D9"};
  font-weight: ${(props) => props.highlight && "700"};
`;

export const Title = styled.div``;

export const DotContainer = styled.div`
  position: relative;
  top: 11px;
  left: ${(props) => (props.engagements || props.applications) && "16px"};
  top: ${(props) => props.mobileDot && "0"};
`;

export const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #79D9D9;
  background-color: ${(props) => props.green && "rgb(39, 174, 96)"};
  background-color: ${(props) => props.offerMade && "rgb(39, 174, 96)"};
  position: absolute;
  top: ${(props) => props.pink && "-6px"};
  top: ${(props) => props.green && "-6px"};
  right: 1px;
  right: ${(props) => props.green && "-17.5px"};
`;

const sharedKanbanLinkSpanStyles = css`
  color: #333 !important;
  display: flex;
  flex: 1;
  transition: 0.1s ease-in-out;
  position: relative;

  &:hover {
    color: #402680 !important;
  }
`;

export const KanbanLink = styled.a`
  ${sharedKanbanLinkSpanStyles}
`;

export const KanbanSpan = styled.span`
  ${sharedKanbanLinkSpanStyles}
`;

export const NumberOfPositions = styled.div`
  display: flex;
  width: 50px;
  justify-content: center;
`;

export const NumberOfPositionsPlaceholder = styled.div`
  width: 50px;
`;
